import { createTRPCClient, httpBatchLink } from '@trpc/client';

// NOTE: appengine側で生成したtRPC型定義を使用する
import type { AppRouter } from '../../trpc-types/appRouter';

// ts-unused-exports:disable-next-line
export const trpcClient = createTRPCClient<AppRouter>({
  links: [
    httpBatchLink({
      url: '/trpc',
      headers: () => {
        return {
          'X-Application-Name': 'balus-webapp',
        };
      },
    }),
  ],
});
